module.exports = __webpack_public_path__ + "static/media/LevelELS.f7928890.png";